let assetBasePath = "";

export function setAssetBasePath(path: string) {
  assetBasePath = path;
}

export function getAssetPath(icon: string) {
  const iconName = icon ? icon : 'no-icon';
  const separator = (assetBasePath && !assetBasePath.endsWith('/') && !iconName.startsWith('/')) ? '/' : '';
  return `${assetBasePath}${separator}${iconName}.png`;
}